import {graphql, useStaticQuery} from "gatsby";
import {useEffect} from "react";

const nameof = obj => Object.keys(obj)[0];

export const useLocalSearchArticles = () => {
  const {localSearchArticles} = useStaticQuery(
    graphql`
      query {
        localSearchArticles {
          index
          store
        }
      }
    `
  );

  useEffect(() => {
    const {index, store} = localSearchArticles;
    const invalidProperties = [index, store]
      .reduce((ps, p) => Boolean(p) && ps || ps.concat([nameof({ p })]), [])
      .join(' and ');

    if (invalidProperties) console.warn(`A flexsearch ${invalidProperties} was not provided.\nFlexsearch results will be unavailable`);
  }, []);

  return localSearchArticles;
};
